<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/print/record/pageByProductInspectionLabelDetail" getKey="rows" :columns="columns"/>
  </div>
</template>

<script>
export default {
  name: "web_quality_management_product_inspection_print_record",
  data() {
    return {
      columns:[
        {
          label: 'biaoqqiantiaoma',
          prop: 'labelBarcodeNumber',
          width: 170
        },{
          label: 'shengchangongdanhao',
          prop: 'woNo',
          width: 170
        },{
          label: 'baozhuangshuliang',
          prop: 'packageNumber',
          width: 80
        },{
          label: 'yibaogongliangpinshu',
          prop: 'goodQuantity',
          width: 110
        },{
          label: 'picihao',
          prop: 'batchNo',
          width: 130
        },{
          label: 'zhijianzhuangtai',
          prop: 'qualityCheckStatus',
          type: 'dictionary_tag',
          key: 'LABEL_QUALITY_CHECK_STATUS',
          width: 80
        },{
          label: 'chuangjianren',
          prop: 'createByObject.nickname',
          width: 130
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          width: 180
        },
      ],
    }
  },
  created() {
    setTimeout(() => {
      this.yt.conditions={
        orderBy: 'createTime desc',
        inspectionRecordId: this.$attrs.inspectionRecordId,
      };
      this.yt.get(1);
    }, 300);
  }
}
</script>

<style scoped>

</style>